import React from "react";
import {Decryption, Encryption, showToastSuccess} from "ubs-framework/v2/common/function";
import moment from 'moment';
import InApp from 'detect-inapp';
import {
    ALLOCATION,
    CONSTANT,
    CURRENCY_LOCALE,
    FORMAT,
    HRMS_STATUS,
    LEAVE,
    LOGIN_METHOD,
    PAGINATION,
    REGEX,
    STATUS_OPTIONS,
    OPERATORS,
    ON_ACTION,
    CUSTOM_FIELD_TYPE,
    D_FIELDS
} from '../constant';
import {
    addDays,
    addMonths,
    addYears,
    differenceInCalendarDays,
    endOfDay,
    endOfMonth,
    endOfWeek,
    endOfYear,
    isSameDay,
    startOfDay,
    startOfMonth,
    startOfWeek,
    startOfYear,
    isAfter,
    isBefore,
} from 'date-fns';
import {getCookie} from "ubs-framework/v2/common/cookie";
import {getKeyName} from 'ubs-framework/v2/common/selector';
import {api} from "../../store/actions";
import * as htmlToImage from 'html-to-image';
import {isInApp} from 'ubs-framework/src/common/function'
import {dateFormatter, localToIST} from "ubs-framework/v2/common/date";
import {APP} from "ubs-framework/v2/common/constant";
import { isArray, isString, isObject, isNumber, isEqual, includes  } from 'lodash';
import cloneDeep from "lodash/cloneDeep";
import {ROUTES} from "../modules";

const defineds = {
    startOfWeek: startOfWeek(new Date()),
    endOfWeek: endOfWeek(new Date()),
    startOfLastWeek: startOfWeek(addDays(new Date(), -6)),
    endOfLastWeek: endOfWeek(addDays(new Date(), -6)),
    startOfToday: startOfDay(new Date()),
    endOfToday: endOfDay(new Date()),
    startOfYesterday: startOfDay(addDays(new Date(), -1)),
    endOfYesterday: endOfDay(addDays(new Date(), -1)),
    startOfMonth: startOfMonth(new Date()),
    endOfMonth: endOfMonth(new Date()),
    startOfLastMonth: startOfMonth(addMonths(new Date(), -1)),
    endOfLastMonth: endOfMonth(addMonths(new Date(), -1)),
    startOfCurrentYear: startOfYear(new Date()),
    endOfCurrentYear: endOfYear(new Date()),
    startOfNextYear: startOfYear(addYears(new Date(), 1)),
    endOfNextYear: endOfYear(addYears(new Date(), 1)),
    startOfLastYear: startOfYear(addYears(new Date(), -1)),
    endOfLastYear: endOfYear(addYears(new Date(), -1))
};

const staticRangeHandler = {
    range: {},
    isSelected(range) {
        const definedRange = this.range();
        return (
            isSameDay(range.startDate, definedRange.startDate) &&
            isSameDay(range.endDate, definedRange.endDate)
        );
    },
};
export const isElectron = () => (typeof window !== 'undefined' && typeof window.process === 'object' && window.process.type === 'renderer') ||
    (typeof process !== 'undefined' && typeof process.versions === 'object' && !!process.versions.electron) ||
    (typeof navigator === 'object' && typeof navigator.userAgent === 'string' && navigator.userAgent.indexOf('Electron') >= 0)
export const detectDevice = () => {
    try {
        const inapp = new InApp(navigator.userAgent || navigator.vendor || window.opera);
        if (isElectron()) return LOGIN_METHOD.DESKTOP
        else if (inapp.isMobile || (inapp.isMobile && inapp.isInApp)) return LOGIN_METHOD.MOBILE
        else if (inapp.isDesktop) return LOGIN_METHOD.WEB
        else return LOGIN_METHOD.WEB
    } catch (e) {
        console.log(':: Detect device error ::', e)
        if (isElectron()) return LOGIN_METHOD.DESKTOP
        else return LOGIN_METHOD.WEB
    }
}

export function createStaticRanges(ranges) {
    return ranges.map(range => ({...staticRangeHandler, ...range}));
}

export const defaultStaticRanges = createStaticRanges([
    {
        label: 'Today',
        range: () => ({
            startDate: defineds.startOfToday,
            endDate: defineds.endOfToday,
        }),
    },
    {
        label: 'Yesterday',
        range: () => ({
            startDate: defineds.startOfYesterday,
            endDate: defineds.endOfYesterday,
        }),
    },
    {
        label: 'Last Week',
        range: () => ({
            startDate: defineds.startOfLastWeek,
            endDate: defineds.endOfLastWeek,
        }),
    },
    {
        label: 'Last Month',
        range: () => ({
            startDate: defineds.startOfLastMonth,
            endDate: defineds.endOfLastMonth,
        }),
    },
    {
        label: 'Current Year',
        range: () => {
            return {
                startDate: defineds.startOfCurrentYear,
                endDate: defineds.endOfCurrentYear,
            }
        },
        rangeType: true
    },
    {
        label: 'Last Year',
        range: () => {
            return {
                startDate: defineds.startOfLastYear,
                endDate: defineds.endOfLastYear,
            }
        },
        rangeType: true
    },
    {
        label: 'Next Year',
        range: () => {
            return {
                startDate: defineds.startOfNextYear,
                endDate: defineds.endOfNextYear,
            }
        },
        rangeType: true
    },
]);
export const defaultInputRanges = [
    {
        label: 'days up to today',
        range(value) {
            return {
                startDate: addDays(defineds.startOfToday, (Math.max(Number(value), 1) - 1) * -1),
                endDate: defineds.endOfToday,
            };
        },
        getCurrentValue(range) {
            if (!isSameDay(range.endDate, defineds.endOfToday)) return '-';
            if (!range.startDate) return '∞';
            return differenceInCalendarDays(defineds.endOfToday, range.startDate) + 1;
        },
    }
];

export const socketHandler = (response) => {
    if (typeof response === 'string') return Decryption(response);
    else return response
}
export const searchInArray = (str, array, key) => {
    return array.filter(data => {
        const pattern = new RegExp(str.toLowerCase());
        if (key) return !!data[key].toLowerCase().match(pattern);
        else return !!data.toLowerCase().match(pattern);
    });
};
export default function createArrayWithNumbers(length) {
    return Array.from({length}, (_, k) => k + 1);
}
export const arrayEquals = (a, b) => {
    return Array.isArray(a) &&
        Array.isArray(b) &&
        a.length === b.length &&
        a.every((val, index) => val === b[index]);
};

export const objectEqual = (object1, object2) => {
    if (object1 && object2) {

        const keys1 = Object.keys(object1);
        const keys2 = Object.keys(object2);

        if (keys1.length !== keys2.length) return false;

        for (let key of keys1) {
            if (object1[key] !== object2[key]) return false;
        }
        return true;
    } else return false;
};
export const random = (length = 16) => {
    return (Math.floor(Math.pow(10, length - 1) + Math.random() * (Math.pow(10, length) - Math.pow(10, length - 1) - 1))).toString();
};
export const randomColor = () => {
    return CONSTANT.COLORS[Math.floor(Math.random() * CONSTANT.COLORS.length)];
};
export const setDate = (date, format) => {
    if (!date) return '';
    if (date?.length === 0) return '';
    return moment(date).format(format);
};
export const dayPipe = (date, flag) => {
    const DATE = moment(date);
    const REFERENCE = moment();
    const TODAY = REFERENCE.clone().startOf('day');
    const YESTERDAY = REFERENCE.clone().subtract(1, 'days').startOf('day');
    if (flag === 'comment') {
        if (DATE.isSame(REFERENCE, 'week')) {
            // Check if date is today, yesterday, weekday or others
            const m = parseInt(moment.duration(REFERENCE.diff(DATE)).asMinutes());
            if (m < 2) return `Just now`;
            else if (m < 60) return `${m} minutes ago`;
            else if (DATE.isSame(TODAY, 'd')) return `Today ${DATE.format(FORMAT.DAY_DATE_MONTH)}`;
            else if (DATE.isSame(YESTERDAY, 'd')) return `Yesterday ${DATE.format(FORMAT.DAY_DATE_MONTH)}`;
            else return DATE.format(FORMAT.DAY_DATE_MONTH);
        } else return DATE.format(FORMAT.DAY_DATE_MONTH);
    } else if (flag === 'time') {
        // If you want only time from date object
        return DATE.format(FORMAT.TIME);

    } else if (flag === 'date') {

        // If you want only date from date object
        if (DATE.isSame(REFERENCE, 'week')) {

            // Check if date is today, yesterday, weekday or others
            if (DATE.isSame(TODAY, 'd')) return DATE.format(FORMAT.TIME);
            else if (DATE.isSame(YESTERDAY, 'd')) return 'Yesterday';
            else return DATE.format('dddd');

        } else return DATE.format(FORMAT.DAY_DATE_MONTH);
    } else {

        // If you want only date and time both from date object
        if (DATE.isSame(REFERENCE, 'week')) {

            // Check if date is today, yesterday, weekday or others
            if (DATE.isSame(TODAY, 'd')) return `Today ${DATE.format(FORMAT.DAY_DATE_MONTH)}`;
            else if (DATE.isSame(YESTERDAY, 'd')) return `Yesterday ${DATE.format(FORMAT.DAY_DATE_MONTH)}`;
            else return DATE.format(FORMAT.DAY_DATE_MONTH);

        } else return DATE.format(FORMAT.DAY_DATE_MONTH);
    }
};
export const bytesToSize = (bytes) => {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 0) return '0 Byte';
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
};

export function timeToMoment12Hours(value, format) {
    if (value) {
        let date = moment();
        let time = moment(value, ["h:mm A"]).format("HH:mm");
        let splitTime = time.split(':');
        if (splitTime?.length > 1) return date.set('hour', splitTime[0]).set('minute', splitTime[1]);
        else return null;
    } else return ''
}

export function stringToTime(value, format = "HH:mm") {
    if (value) {
        let date = new Date();
        let time = moment(value, [format]).format("HH:mm");
        let splitTime = time.split(':');
        date.setHours(splitTime[0])
        date.setMinutes(splitTime[1])
        date.setSeconds(0)
        date.setMilliseconds(0)
        if (splitTime?.length > 1) return date;
        else return null;
    } else return ''
}

export function minutesToNumberString(value, isHM) {
    if (value <= 1440) {
        let hour = Math.floor(parseFloat(Math.abs(value)) / 60)?.toString()?.padStart(2, '0') || "00";
        let minute = Math.round(parseFloat(Math.abs(value)) % 60)?.toString()?.padStart(2, '0') || "00";
        if (isHM) return `${hour}H:${minute}M`
        return hour + ":" + minute || "00:00";
    } else return "00:00"
}

export function hourToMinute(value) {
    /**
     * value must be in HH:MM
     * */
    if (value && typeof value === 'string') return Math.floor(Number(value?.split(":")[0]) * 60 + Number(value?.split(":")[1]));
    else if (typeof value === "number") return minutesToNumberString(value)
    else return 0
}

export function diffInMinute(start, end) {
    /**
     * start and end must be in HH:MM format and return total diffrence in minutes
     * */
    if (start && end) {
        let LocalStart = hourToMinute(start)
        let localEnd = hourToMinute(end);
        if (localEnd >= LocalStart) {
            return localEnd - LocalStart
        } else 0
    } else return 0
}

export const convertTime = (secs) => {
    if (!secs || secs === 0 || secs < 0) return '00:00:00'
    const digit = d => d.toString().length === 1 ? `0${d}` : d;

    const h = digit(Math.floor(secs / (60 * 60)));

    const divisor_for_minutes = secs % (60 * 60);
    const m = digit(Math.floor(divisor_for_minutes / 60));

    const s = digit(Math.ceil(divisor_for_minutes % 60));
    return `${h}:${m}:${s}`;
}
export const monthDiff = (startdate, enddate) => {
    // return d2?.getMonth() - d1?.getMonth() +  (12 * (d2?.getFullYear() - d1?.getFullYear()))
    let startdateMoment = moment(startdate).set({hour: 0, minute: 0, second: 0, millisecond: 0})
    let enddateMoment = moment(enddate).set({hour: 23, minute: 59, second: 59, millisecond: 999}).add(1, 'second')

    if (startdateMoment.isValid() === true && enddateMoment.isValid() === true) {
        //getting the difference in years
        let years = enddateMoment.diff(startdateMoment, 'years');
        //moment returns the total months between the two dates, subtracting the years
        startdateMoment.add(years, 'years')
        let months = enddateMoment.diff(startdateMoment, 'months');
        if (years > 0) months += (years * 12)
        return months;
    }
}
export const autosize = (field) => {
    setTimeout(function () {
        field.style.cssText = 'height:auto; padding:0';
        // for box-sizing other than "content-box" use:
        // el.style.cssText = '-moz-box-sizing:content-box';
        field.style.cssText = 'height:' + (field.scrollHeight + 40) + 'px';
    }, 0);
}
export const timeDiff = (d1, d2) => {
    d1 = moment(d1);
    d2 = moment(d2);
    if (d1?.isSameOrBefore(d2)) return 1;
    else if (d1?.isSameOrBefore(moment())) {
        let duration = moment.duration(d1?.diff(d2));
        let hours = parseInt(duration.asHours());
        let minutes = parseInt(duration.asMinutes()) % 60;
        // if(hours < 0) hours += 24;
        // if(minutes < 0) minutes += 60;
        if (hours >= 0 && hours < 10) hours = '0' + hours;
        if (minutes >= 0 && minutes < 10) minutes = '0' + minutes
        if (hours > 0 || minutes > 0) return `${hours} H : ${minutes} M`;
        else if (hours <= 0 || minutes <= 0) return 1;
    } else return 2;
}

export const secondsToHms = (d, flag) => {
    if (d < 0) d = d * -1
    d = Number(d);
    let h = Math.floor(d / 3600);
    let m = Math.floor(d % 3600 / 60);
    let s = Math.floor(d % 3600 % 60);
    if (h < 10) h = '0' + h;
    if (m < 10) m = '0' + m;
    if (s < 10) s = '0' + s;
    if (flag) return `${h} H : ${m} M : ${s} S`;
    else return `${h}:${m}:${s}`;
}
export const secondsToHs = (d, flag) => {
    d = Number(d);
    let h = Math.floor(d / 3600);
    let m = Math.floor(d % 3600 / 60);
    let s = Math.floor(d % 3600 % 60);
    if (h < 10) h = '0' + h;
    if (m < 10) m = '0' + m;
    if (s < 10) s = '0' + s;
    if (flag) {
        if(s > 0) return `${h} H : ${m} M : ${s} S`;
        else return `${h} H : ${m} M`;
    }
    else return `${h}:${m}:${s}`;
}
export const secondsToHm = (d, flag) => {
    if (d < 0) d = d * -1
    d = Number(d);
    let h = Math.floor(d / 3600);
    let m = Math.floor(d % 3600 / 60);
    if (h < 10) h = '0' + h;
    if (m < 10) m = '0' + m;
    if (flag) return `${h} H : ${m} M`;
    else return `${h}:${m}`;
}

export const minutesToHm = (d, flag, isHrs = false) => {
    let isNegative = (Math.sign(d) === -1) ? true : false;
    if (d < 0) d = d * -1
    d = Number(d);
    let h = Math.floor(d / 60);
    /** need precision in minutes but not in hours so round method selected if we select floor it will loose 1 minute.*/
    let m = Math.round(d % 60);
    if (h < 10) h = '0' + h;
    if (m < 10) m = '0' + m;
    if (isHrs) {
        return `${h} Hrs : ${m} Mins`
    }
    if (flag && isNegative) {
        return `-${h}H : ${m}M`
    } else if (flag) {
        return `${h}H : ${m}M`
    } else return `${h}:${m}`;
}

export function minutesTo12Hour(minutes = 0) {
    return timeToMoment12Hours(minutesToHm(minutes)).format('h:mm A') || "12:00AM"
}

export function getDiffrenceInMinute(start, end) {
    if (start && end && ![typeof start, typeof end]?.includes('number')) {
        start = start?.split(":");
        end = end?.split(":");
        let startDate = new Date(0, 0, 0, start[0], start[1], 0);
        let endDate = new Date(0, 0, 0, end[0], end[1], 0);
        let diff = endDate.getTime() - startDate.getTime();
        //if(diff < 0) diff = Math.abs(diff)
        let hours = Math.floor(diff / 1000 / 60 / 60);
        let tempHr = Math.floor(diff / 1000 / 60 / 60);
        if (hours < 0) hours += 24
        diff -= tempHr * 1000 * 60 * 60;
        let minutes = Math.floor(diff / 1000 / 60);
        if (minutes < 0) minutes = Math.abs(minutes)
        return (hours <= 9 ? "0" : "") + hours + ' Hrs ' + " " + (minutes <= 9 ? "0" : "") + minutes + ' Mins';
    } else {
        if (start && end) {
            return minutesToHm(end - start, true, true)
        }
    }
}

export const spiltContact = (num) => {
    if (num?.length > 0) {
        return num.split('-')
    } else return ''
}
export const joinContact = (code, number) => `${code}-${number}`
export const getName = (user) => {
    return user?.name || `${user ? user?.firstName : '-'} ${user ? user?.lastName : '-'}`
}
export const getFullNameWithMiddleName = (fname, mname, lname) => {
    return `${fname || ''} ${mname || ''} ${lname || ''}`
}
export const loadOptions = (input, cb, list) => {
    const result = list?.filter(i =>
        getName(i).toLowerCase().includes(input.toLowerCase())
    );
    cb(result)
}
export const getPaginateWithSearchList = ({list = [], currentPage = PAGINATION.currentPage, limit = PAGINATION.limit, search = ''}) => {
    list = list.filter(data => {
        const pattern = new RegExp(search?.toLowerCase());
        return !!data?.name?.toLowerCase()?.match(pattern);
    });
    return list.slice((currentPage - 1) * limit, currentPage * limit)
}
export const dateDiff = (d1, d2) => {
    const Difference_In_Time = new Date(d1)?.getTime() - new Date(d2)?.getTime();
    // To calculate the no. of days between two dates
    return Difference_In_Time / (1000 * 3600 * 24)
}
export const timeStampUnix = (date) => {
    return moment(date).valueOf()
}
export const getDateByTime = (time, format) => {
    let date = time.split(':')
    if (date?.length > 1 && format) {
        return moment().set({hour: date[0], minute: date[1]}).format(format);
    } else if (date?.length > 1) {
        return moment().set({hour: date[0], minute: date[1]})
    }
}
export const getTimeDifference = (start, end) => {
    if (start && end) {
        start = start?.split(":");
        end = end?.split(":");
        let startDate = new Date(0, 0, 0, start[0], start[1], 0);
        let endDate = new Date(0, 0, 0, end[0], end[1], 0);
        let diff = endDate.getTime() - startDate.getTime();
        //if(diff < 0) diff = Math.abs(diff)
        let hours = Math.floor(diff / 1000 / 60 / 60);
        let tempHr = Math.floor(diff / 1000 / 60 / 60);
        if (hours < 0) hours += 24
        diff -= tempHr * 1000 * 60 * 60;
        let minutes = Math.floor(diff / 1000 / 60);
        if (minutes < 0) minutes = Math.abs(minutes)
        return (hours <= 9 ? "0" : "") + hours + ' Hrs ' + " " + (minutes <= 9 ? "0" : "") + minutes + ' Mins';
    }
}
export const checkPlusDay = (d1, date, timezone) => {
    d1 = moment(d1).set({hour: 0, minute: 0, second: 0})
    if (d1 && d1?.diff(date, 'day') > 0) return true;
    else return false;
}
export const showFilterDateRange = (date, filterName = 'Date') => {
    let filterStartDate = date[0]?.startDate ? moment(date[0]?.startDate).format('D MMM YY') : `Select ${filterName}`;
    let filterEndDate = date[0]?.endDate ? moment(date[0]?.endDate).format('D MMM YY') : `Select ${filterName}`;

    filterEndDate = filterStartDate === filterEndDate ? '' : ` - ${filterEndDate}`;

    return date.length !== 0 ? `${filterName}: ${filterStartDate}${filterEndDate}` : `${filterName}`;
}
export const hexToRgba = (hex, alpha) => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    const bg_color = result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
    return `rgba(${bg_color?.r}, ${bg_color?.g}, ${bg_color?.b}, ${alpha ? alpha : 1})`;
}
export const totalRecords = (length) => {
    return (length > 0 && length < 10) ? `0${length}` : length;
}
export const durationCalc = (enddate, startdate) => {
    //define moments for the startdate and enddate

    let startdateMoment = moment(startdate).set({hour: 0, minute: 0, second: 0, millisecond: 0})
    let enddateMoment = moment(enddate).set({hour: 23, minute: 59, second: 59, millisecond: 999}).add(1, 'second')

    if (startdateMoment.isValid() === true && enddateMoment.isValid() === true) {
        //getting the difference in years
        let years = enddateMoment.diff(startdateMoment, 'years');
        //moment returns the total months between the two dates, subtracting the years
        startdateMoment.add(years, 'years')
        let months = enddateMoment.diff(startdateMoment, 'months');

        //to calculate the days, first get the previous month and then subtract it
        startdateMoment.add(months, 'months');
        let days = enddateMoment.diff(startdateMoment, 'days')

        let timing = ''

        if (years) timing += `${years} Year `
        if (months) timing += `${months} ${months > 1 ? 'Months ' : 'Month '}`
        if (days) timing += `${days} ${days > 1 ? 'Days ' : 'Day '}`
        return timing;
    } else {
        return undefined;
    }
}
export const getReportTo = (list) => {
    let reportToOptions = [];
    list?.map(item => {
        reportToOptions.push({
            label: getName(item),
            value: item?._id,
            profileImage: item?.profileImage ? item?.profileImage : ''
        });
    });

    return reportToOptions?.length ? reportToOptions : null;
}
export const isValidShiftTiming = (weekend) => {
    let errors = false;

    let weekErrors = {};
    for (const [key, value] of Object.entries(weekend)) {
        let tempKey = key;
        weekErrors[HRMS_STATUS?.WEEK_NUMBER[tempKey]] = [];
        if (value) {
            if (value?.workStartAt === "" && value.workEndAt === "") {
                value.weekendDays.forEach(_ => {
                    if (_.workStartAt === "" && _.workEndAt === "") {
                        if (_?.weeknumber !== 6 && (_.type === HRMS_STATUS?.WEEKEND_TYPE?.FIRSTHALF || _.type === HRMS_STATUS?.WEEKEND_TYPE?.SECONDHALF || _.type === HRMS_STATUS?.WEEKEND_TYPE.WORK)) {
                            weekErrors[HRMS_STATUS?.WEEK_NUMBER[tempKey]].push(_?.weeknumber);
                            errors = {error: "Please enter valid time in Weekend Definition", code: 400};
                        }
                    }
                });
            } else {
                value.weekendDays.forEach(_ => {
                    if (_?.weeknumber !== 6 && (_.type === HRMS_STATUS?.WEEKEND_TYPE.FIRSTHALF && _.type === HRMS_STATUS?.WEEKEND_TYPE?.SECONDHALF)) {
                        if (_.workStartAt === "" && _.workEndAt === "") {
                            weekErrors[HRMS_STATUS.WEEK_NUMBER[tempKey]].push(_?.weeknumber);
                            errors = {error: "Please enter valid time in Weekend Definition", code: 400};
                        }
                    }
                })
            }
        }
    }
    let string = "";
    if (errors != false) {
        Object.entries(weekErrors)?.forEach((e) => {
            if (e[1].length > 0) {
                string = string.concat(`${e[0]} : `);
                e[1].forEach((_, i) => {
                    string = string.concat(`${_ + "" + HRMS_STATUS?.TAG_CODES[_ - 1]}, `);
                });
                string = string + '</br>'
            }
        });
        // string = string.slice(0, string.length - 2);
        string = string.concat(` is required OR configure working hours`)
        errors.error = string;
    }
    return errors;
}
export const getDate = (date, flag = 'start') => {
    const day = (date || date?.length !== 0) ? new Date(date) : new Date()
    return day.setHours(flag === 'start' ? 0 : 23, flag === 'start' ? 0 : 59, flag === 'start' ? 0 : 59, flag === 'start' ? 0 : 999);
}
export const getOffset = () => {
    const now = new Date();
    const offsetMinutes = now.getTimezoneOffset();
    const offsetHours = Math.abs(Math.floor(offsetMinutes / 60));
    const offsetMinutesRemainder = Math.abs(offsetMinutes % 60);
    const offsetSign = offsetMinutes > 0 ? '-' : '+';
    return `${offsetSign}${offsetHours.toString().padStart(2, '0')}:${offsetMinutesRemainder.toString().padStart(2, '0')}`;
}

export const sameDay = (d1, d2) => {
    const date1 = new Date(d1)
    const date2 = new Date(d2)
    return date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate();
}
export const errorFocus = (flag) => {
    setTimeout(() => {
        const elem = document.getElementsByClassName('u_input-error')
        if (elem && elem[0]) {

            if (flag === 'top') elem[0].scrollIntoView({behavior: "smooth"});
            else elem[0].scrollIntoView({behavior: "smooth", block: "nearest", inline: 'nearest'});
        }
    }, 200)
}

//                         route | employeeID |mainRoute | innerRoute | Login userID
export const checkRoute = (key, splitID, mainRoute, innerRoute, superID) => {
    if (key === ROUTES.myProfile && mainRoute) return true;
    else if (key === ROUTES.employeeProfile && !innerRoute && superID === splitID) return true;
    else if (key === ROUTES.employeeProfile && innerRoute && superID !== splitID) return true;

    if (key === 'my-profile' && mainRoute) return true;
    else if (key === 'employees' && !innerRoute && superID === splitID) return true;
    else if (key === 'employees' && innerRoute && superID !== splitID) return true;
    else return false
}
//                             route | employeeID |mainRoute | innerRoute | Login userID
export const checkBasicInfo = (key, splitID, mainRoute, innerRoute, innerIDProofField, innerDateField, superID) => {
    if (key === 'my-profile' && mainRoute) return true;
    else if (key === 'employees' && !innerRoute && superID === splitID) return true;
    else if (key === 'employees' && innerRoute && superID !== splitID) return true;
    else if (key === 'employees' && !innerRoute && innerIDProofField) return true;
    else if (key === 'employees' && innerRoute && innerIDProofField) return true;
    else if (key === 'employees' && !innerRoute && innerDateField) return true;
    else if (key === 'employees' && innerRoute && innerDateField) return true;

    if (key === ROUTES.myProfile && mainRoute) return true;
    else if (key === ROUTES.employeeProfile && !innerRoute && superID === splitID) return true;
    else if (key === ROUTES.employeeProfile && innerRoute && superID !== splitID) return true;
    else if (key === ROUTES.employeeProfile && !innerRoute && innerIDProofField) return true;
    else if (key === ROUTES.employeeProfile && innerRoute && innerIDProofField) return true;
    else if (key === ROUTES.employeeProfile && !innerRoute && innerDateField) return true;
    else if (key === ROUTES.employeeProfile && innerRoute && innerDateField) return true;
    else return false
}
export const generateYears = (prev = 5, next = 1, year) => {
    const years = []
    if (year && year >= 2020) prev = new Date().getFullYear() - year + 1
    for (let i = 1; i <= next; i++) {
        const y = new Date().getFullYear() + (i)
        years.push({label: y, value: y});
    }
    for (let i = 0; i < prev; i++) {
        const y = new Date().getFullYear() - (i)
        years.push({label: y, value: y});
    }
    return years
}

export function ordinalSuffixOf(i) {
    let j = i % 10, k = i % 100;
    if (j === 1 && k !== 11) return "st";
    if (j === 2 && k !== 12) return "nd";
    if (j === 3 && k !== 13) return "rd";
    return "th";
}

export function numberToWord(number) {
    number = Math.abs(number);
    const NS = [
        {value: 10000000, str: "Crore"},
        {value: 100000, str: "Lakh"},
        {value: 1000, str: "Thousand"},
        {value: 100, str: "Hundred"},
        {value: 90, str: "Ninety"},
        {value: 80, str: "Eighty"},
        {value: 70, str: "Seventy"},
        {value: 60, str: "Sixty"},
        {value: 50, str: "Fifty"},
        {value: 40, str: "Forty"},
        {value: 30, str: "Thirty"},
        {value: 20, str: "Twenty"},
        {value: 19, str: "Nineteen"},
        {value: 18, str: "Eighteen"},
        {value: 17, str: "Seventeen"},
        {value: 16, str: "Sixteen"},
        {value: 15, str: "Fifteen"},
        {value: 14, str: "Fourteen"},
        {value: 13, str: "Thirteen"},
        {value: 12, str: "Twelve"},
        {value: 11, str: "Eleven"},
        {value: 10, str: "Ten"},
        {value: 9, str: "Nine"},
        {value: 8, str: "Eight"},
        {value: 7, str: "Seven"},
        {value: 6, str: "Six"},
        {value: 5, str: "Five"},
        {value: 4, str: "Four"},
        {value: 3, str: "Three"},
        {value: 2, str: "Two"},
        {value: 1, str: "One"}
    ];

    let result = '';
    for (let n of NS) {
        if (number >= n.value) {
            if (number <= 99) {
                result += n.str;
                number -= n.value;
                if (number > 0) result += ' ';
            } else {
                let t = Math.floor(number / n.value);
                let d = number % n.value;
                if (d > 0) {
                    return numberToWord(t) + ' ' + n.str + ' ' + numberToWord(d);
                } else {
                    return numberToWord(t) + ' ' + n.str;
                }
            }
        }
    }
    return result;
}

export const isMobileTablet = () => {
    let check = false;
    (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)))
            check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
}
export const getYears = (dateYear, yearCount = 0) => {
    let years = []
    let startYear = new Date(dateYear).getFullYear();
    const year = new Date().getFullYear();
    for (let start = startYear; start <= (year + yearCount); start++) {
        years.push({label: `${start}`, value: `${start}`})
    }
    return years;
}
export const numberWithComaToFixed = (n, code, removeZero = false) => {
    const num = Number(n);
    if (isNaN(num)) return '';

    // Check if the number has decimals
    const hasDecimals = num % 1 !== 0;

    if (code) {
        return num?.toLocaleString(CURRENCY_LOCALE[code]?.language || 'en-IN',
            {
                style: 'currency',
                currency: code,
                minimumFractionDigits: (removeZero && !hasDecimals) ? 0 : 2,
                maximumFractionDigits: (removeZero && !hasDecimals) ? 0 : 2
            });
    } else {
        return num?.toLocaleString(CURRENCY_LOCALE[code]?.language || 'en-IN');
    }
}
export const getPreviousMonth = () => {
    return LEAVE?.month?.find(e => e?.value === (new Date()?.getMonth() === 0 ? 1 : new Date()?.getMonth()))
}
export const getCurrentMonth = () => {
    const currentMonth = new Date().getMonth() + 1; // getMonth() returns 0 for January, adding 1 to align with month numbers
    return LEAVE?.month?.find(e => e?.value === currentMonth);
}
export const getSandwichRule = (leaveDays = []) => {
    let flag = []
    leaveDays.forEach(e => {
        if (e.isLeave === true && e.dayStatus !== 3 && e.dayStatus !== 4 && e.dayStatus !== 5) flag.push(e.dayStatus)
    })
    return flag
}
export const getCurrentYear = () => {
    return getYears(new Date())?.find(e => e?.value == (new Date()?.getFullYear()))
}
export const isMobileDevice = () => {
    return ('ontouchstart' in document.documentElement);
}
export const copyLink = (link, text) => {
    navigator.clipboard.writeText(link);
    showToastSuccess(`${text} link copied to clipboard.`);
};
export const downloadFile = (filePath) => {
    let link = document.createElement('a');
    link.href = filePath;
    link.download = filePath.substr(filePath.lastIndexOf('/') + 1);
    link.click();
}
export const paginate = (array, page_size, page_number) => {
    // human-readable page numbers usually start with 1, so we reduce 1 in the first argument
    return array.slice((page_number - 1) * page_size, page_number * page_size);
}

export function checkMinLength(value, length) {
    return value && value.length >= length
}

export function checkUppercase(value) {
    return (REGEX.upperCase.test(value));
}

export function checkLowercase(value) {
    if (value) return (REGEX.lowerCase.test(value));
    else return false
}

export function checkNumeric(value) {
    return REGEX.number.test(value)
}

export function checkSpecialCharacter(value) {
    return REGEX.specialChar.test(value)
}

export function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
        return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
    }

    return "unknown";
}

export const getThumbor = (dimension = '48x48', quality = 80) => {
    if (process.env.REACT_APP_THUMBOR_URL) return `${process.env.REACT_APP_THUMBOR_URL}/${dimension}/filters:quality(${quality})/`
    else return ''
}
export const isInViewport = (element, ref) => {
    return (
        element.getBoundingClientRect().top >= 0 &&
        element.getBoundingClientRect().bottom <= (ref.innerHeight || document.documentElement.clientHeight)
    );
}
export const objectCompare = (object1, object2) => {
    if (!object1) object1 = {}
    if (!object2) object2 = {}
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return true;

    for (let key of keys1) {
        if (object1[key] !== object2[key]) return true;
    }

    return false;
}
// function to convert string in uppercase "string".toCapitalize() = 'String'
Object.defineProperty(String.prototype, 'toCapitalize', {
    value: function () {
        return this.charAt(0).toUpperCase() + this.slice(1).toLowerCase();
    },
    enumerable: false
});
// function to convert string in uppercase "string".toCapitalize() = 'String'
Object.defineProperty(Date.prototype, 'stamp', {
    value: function () {
        return this ? new Date(this).getTime() : this;
    },
    enumerable: false
});
Object.defineProperty(String.prototype, 'stamp', {
    value: function () {
        return this ? new Date(this).getTime() : this;
    },
    enumerable: false
});
export const htmlToDataURL = (content) => {
    return new Promise((resolve, reject) => {
        let iframe = document.createElement('iframe');
        document.body.appendChild(iframe);
        let iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
        iframeDoc.body.innerHTML = content;
        htmlToImage.toPng(iframeDoc.body, {width: 1000, height: 900})
            .then(function (dataUrl) {
                resolve(dataUrl)
            })
            .catch(function (error) {
                resolve('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAH0AAACmCAIAAAB4GxeeAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAFkSURBVHhe7dAxAQAADMOg+TfdyeAJErhF6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ehd2B5QkEUFx84t2QAAAABJRU5ErkJggg==')
                console.error('oops, something went wrong in html to image!', error);
            });
    })
}
export const getDaysLength = (date1, date2) => {
    const singleDay = 24 * 60 * 60 * 1000
    return Math.ceil((new Date(date2).getTime() - new Date(date1).getTime()) / singleDay)
}
export const getDaysArray = (date1, date2) => {
    const singleDay = 24 * 60 * 60 * 1000
    const length = Math.ceil((new Date(date2).getTime() - new Date(date1).getTime()) / singleDay)
    return (new Array(length)).fill('').map((v, i) => new Date(date1 + (i * singleDay)));
}
export const getFiltersLen = (filters) => {
    return Object.values(filters)?.filter(x => x !== null && x !== '' && x !== undefined && x?.length !== 0)?.length;
}
export const bottomTouch = (e, gap = false) => {
    return Math.ceil(e.target.scrollTop) + Math.ceil(e.target.clientHeight) >= Math.ceil(e.target.scrollHeight) - (gap ? (Math.ceil(e.target.clientHeight) * 0.8) : 0)
}
export const compareFilterDates = (date, newDate) => {
    let filteredDates;
    if(date) filteredDates = JSON.parse(date);
    let isMatch = dateFormatter({
        date: filteredDates?.[0]?.startDate, format: 'DD/MM/YYYY'
    }) === dateFormatter({
        date: newDate?.[0]?.startDate, format: 'DD/MM/YYYY'
    }) && dateFormatter({
        date: filteredDates?.[0]?.endDate, format: 'DD/MM/YYYY'
    }) === dateFormatter({
        date: newDate?.[0]?.endDate, format: 'DD/MM/YYYY'
    });
    return isMatch ? '' : 1;
}
export const getProfileUpdateValue = (value, name, _ID_LV, _FS_LV) => {
    let str = value;
    if (name === 'relation') {
        str = getKeyName(_FS_LV, value)?.label;
    }
    if (name === 'dob') {
        str = dateFormatter({date: value, format: 'DD/MM/YYYY', timezone: APP.DEFAULT_TZ})
    }
    if (name === 'bloodGroup') {
        str = CONSTANT.BLOOD_GROUP_LIST?.find(e => e?.value === value)?.label;
    }
    if (name === 'proofType') {
        str = _ID_LV?.find(e => e?.value === value)?.label;
    }
    if (name === 'isPrimary') {
        str = str ? 'Yes' : 'No'
    }
    if (name === 'isActive') {
        str = str ? 'Yes' : 'No'
    }
    if (name === 'isAddSameAsPermanent') {
        str = str ? 'Yes' : 'No'
    }
    if (name === 'bankId') {
        str = value?.name
    }
    return str || '--';
}
export const getProfileUpdateLabel = (value, data) => {

    let str = (data?.type?.includes('IdProof') && value === 'attachments') ? '' : value?.split(/(?=[A-Z0-9])/).join(' ');

    if (value === 'accHolderName') {
        str = 'Account Holder Name'
    }
    if (value === 'branch') {
        str = 'Bank Branch'
    }
    if (value === 'dob') {
        str = 'Date of Birth'
    }
    if (value === 'bornPlace') {
        str = 'Place of Birth'
    }
    if (value === 'isPrimary') {
        str = 'Primary Contact'
    }
    if (value === 'isAddSameAsPermanent') {
        str = 'Same as Current Address'
    }
    if (value === 'ifsc') {
        str = 'IFSC Code'
    }
    if (value === 'isActive') {
        str = 'Active'
    }
    if (value === 'address1') {
        str = 'Current Address1'
    }
    if (value === 'address2') {
        str = 'Current Address2'
    }
    if (value === 'city') {
        str = 'Current City'
    }
    if (value === 'country') {
        str = 'Current Country'
    }
    if (value === 'province') {
        str = 'Current State'
    }
    if (value === 'zip') {
        str = 'Current Pin Code'
    }
    if (value === 'bankId') {
        str = 'Bank Name'
    }
    if (value === 'accountNo') {
        str = 'Account Number'
    }
    if (value === 'permanentProvince') {
        str = 'permanent State'
    }
    if (value === 'permanentZip') {
        str = 'permanent Pin Code'
    }
    if (value === 'addIdProof') {
        str = 'Add Document'
    }
    if (value === 'updateIdProof') {
        str = 'Update Document'
    }
    if (value === 'deleteIdProof') {
        str = 'Delete Document'
    }
    if (value === 'deleteIdProofFiles') {
        str = 'Delete Document Attachment'
    }
    if (value === 'attachments' && data?.profileType === 'Bank Info') {
        str = 'Bank info Attachments'
    }
    if (value === 'countryType') {
        str = 'country Name'
    }

    return str;
}
export const getStatusInfo = (status, type) => {
    return STATUS_OPTIONS.find(_ => _.value === status)?.[type];
}
export const getFixed = (number = 0, precision = 3) => {
    var factor = Math.pow(10, precision);
    return Math.round(number * factor) / factor;
}
export const getPlural = (prefix, value = 0) => {
    return `${getFixed(value, 3)} ${prefix}${value > 1 ? 's' : ''}`;
}
export const monthsBetween = (...args) => {
    let [a, b] = args.map(arg => arg.split("-").slice(0, 2).reduce((y, m) => m - 1 + y * 12));
    return Array.from({length: b - a + 1}, _ => a++).map(m => ~~(m / 12) + "-" + ("0" + (m % 12 + 1)).slice(-2) + "-01");
}
export const uploadHRMSFile = ({
                                   event = '',
                                   file = [],
                                   data = {},
                                   socketId = '',
                                   orgId = '',
                                   onUploadProgress = () => {
                                   },
                                   route = '/hrmsFileUpload',
                                   encrypt = true,
                                   onSuccess = () => {
                                   },
                                   bodyData = {}
                               }) => {
    return new Promise((resolve, reject) => {
        const payload = {}
        const fileFormData = []
        if (!event) resolve({error: true, message: 'Event is required'})
        for (let i = 0; i < file.length; i++) {
            let e = file[i]
            const rId = e?.rId || Math.random().toString(36).substr(2, 9).toString();
            if (e?.rId) e = e.obj
            payload[rId] = {
                size: e?.size,
                fileName: e?.name,
                mimeType: e?.type,
                lastModified: e?.lastModified,
            };
            fileFormData.push({key: rId, file: e});

        }
        const body = {
            event,
            "data": {
                ...(file.length && {payload}),
                ...data
            },
            orgId,
            socketId,
            ...((typeof bodyData === 'object' && bodyData !== null) && bodyData)
        }
        console.log(route, ' body', body, fileFormData)
        const formData = new FormData();
        formData.append('body', encrypt ? Encryption(body) : body);
        if (fileFormData?.length) {
            fileFormData.forEach(e => {
                formData.append(e.key, e.file);
            });
        }
        formData.append('finish', true);
        const config = {
            headers: {'Authorization': `Bearer ${getCookie('ubs_token')}`},
            onUploadProgress: e => {
                onUploadProgress(parseInt(e.loaded / e.total * 100));
            },
        };
        api.post(route, formData, config).then(res => {
            console.log(`Files uploaded: `, res?.data)
            resolve(res)
        }).catch((err) => {
            console.log(`Error in file upload: (${event}) ` + err?.message)
            resolve({error: true, message: 'Failed to upload file'})
        })
    })
}
export const isThisAFile = (maybeFile) => {
    return new Promise(function (resolve, reject) {
        if (maybeFile.type !== '') {
            return resolve(maybeFile);
        }
        const reader = new FileReader();
        reader.onloadend = () => {
            if (reader.error && reader.error.name === 'NotFoundError') {
                return reject(reader.error.name);
            }
            resolve(maybeFile);
        };
        reader.readAsBinaryString(maybeFile);
    });
};
export const checkAttachment = (url) => {
    if (url) {
        const name = url?.split('.');
        const ext = name[name?.length - 1];
        return ext;
    }
}
export const openLinks = (link) => {
    if (isInApp()) window.location.href = link
    else window.open(link, '_blank')
}
export const handleCommentReaction = (commentList, data, _id) => {
    return commentList?.map(comment => {
        if (comment?._id === data?.commentId) {
            let reactionData = [...(comment.reactionData || [])]
            const index = reactionData.findIndex(e => e._id === data.reaction)

            if (index !== -1) {
                if (data.actionBy === _id) reactionData[index].isLike = data.revert ? 0 : 1
                const count = reactionData[index].count + (data.revert ? -1 : 1)
                if (count === 0) reactionData.splice(index, 1)
                else {
                    reactionData[index].count = count
                    const userIds = reactionData[index]?.userIds || []
                    if (data.revert) userIds.splice(userIds.indexOf(data.actionBy), 1);
                    else userIds.push(data.actionBy)
                    reactionData[index].userIds = userIds
                }
            } else if (!data.revert) {
                reactionData.push({
                    _id: data?.reaction,
                    isLike: data.actionBy === _id ? 1 : 0,
                    count: 1,
                    userIds: [data.actionBy]
                })
            }

            comment.reactionData = [...reactionData]
        }
        return comment;
    });
}
export const handleCommentUser = (dispatch, arr) => {

    let userIds = []

    arr.map(comment => {
        userIds.push(comment?.user)
        comment.reactionData.map(e => {
            userIds = [...userIds, ...e.userIds]
        })
    })
    userIds = userIds.filter(e => e)
    if (userIds.length !== 0) dispatch({
        type: 'FIND_MASTER_DATA_LIST',
        payload: {findUserIdsList: [...new Set(userIds)]}
    })
}
export const getDatesBetweenDates = (startDate, endDate) => {
    let dates = [];
    const start_date = new Date(new Date(startDate).setHours(0, 0, 0, 0));
    const end_date = new Date(new Date(endDate).setHours(0, 0, 0, 0));

    while (start_date < end_date) {
        dates = [...dates, new Date(start_date).getTime()];
        start_date.setDate(start_date?.getDate() + 1);
    }
    dates = [...dates, new Date(end_date).getTime()];

    return dates;
}
export const getISTDatesBetweenDates = (startDate, endDate) => {
    if (!endDate) endDate = startDate
    let dates = [];
    const start_date = new Date(new Date(startDate).setHours(0, 0, 0, 0));
    const end_date = new Date(new Date(endDate).setHours(0, 0, 0, 0));

    while (start_date < end_date) {
        dates.push(localToIST(start_date));
        start_date.setDate(start_date?.getDate() + 1);
    }
    dates.push(localToIST(end_date));
    return dates;
}
export const convertTimeStringToNumber = (estimatedTime) => {
    if (typeof estimatedTime != 'string') {
        if (typeof estimatedTime == 'number')
            return estimatedTime;
        else
            return 0;
    }

    estimatedTime = estimatedTime.trim();
    let splitted = estimatedTime.split(':');
    let hour = !isNaN(splitted[0]) ? Number(splitted[0]) : 0, minute = !isNaN(splitted[1]) ? Number(splitted[1]) : 0;

    return (hour * 60 * 60) + (minute * 60);
}
export const convertTimeNumberToString = (sec) => {
    let hours = Math.floor(sec / 3600);
    (hours >= 1) ? sec = sec - (hours * 3600) : hours = '00';
    hours = hours > 9 ? "" + hours : "0" + hours;
    let min = Math.floor(sec / 60);
    (min >= 1) ? sec = sec - (min * 60) : min = '00';
    (sec < 1) ? sec = '00' : void 0;

    (min.toString().length === 1) ? min = '0' + min : void 0;
    return hours + ':' + min;
}
export const checkDate = (date) => {
    // 'Older',
    // 'Yesterday',
    // 'Today',
    // 'Tomorrow',
    // 'This Week',
    // 'This Month',
    // 'Upcoming',
    // 'No Due Date'

    const FORMAT = 'YYYY-MM-DD'
    const momentDate = moment(date);
    const REFERENCE = moment();
    const TODAY = REFERENCE.clone().startOf('day');
    const YESTERDAY = REFERENCE.clone().subtract(1, 'days').startOf('day');
    const TOMORROW = REFERENCE.clone().add(1, 'days').startOf('day');
    const WEEK_START = REFERENCE.clone().add(1, 'days').startOf('day');
    const WEEK_END = REFERENCE.clone().endOf('week')
    const MONTH_END = REFERENCE.clone().endOf('month').add(1, 'days').startOf('day');
    const MONTH_NEXT = REFERENCE.clone().endOf('month').startOf('day');

    if (momentDate.isBefore(YESTERDAY)) {
        return 'Older';
    } else if (momentDate.isSame(YESTERDAY, 'd')) {
        return 'Yesterday';
    } else if (momentDate.isSame(TODAY, 'd')) {
        return 'Today';
    } else if (momentDate.isSame(TOMORROW, 'd')) {
        return 'Tomorrow';
    } else if (moment(momentDate.clone().format(FORMAT)).isBetween(WEEK_START.clone().format(FORMAT), WEEK_END.clone().format(FORMAT))) {
        return 'This Week';
    } else if (moment(momentDate.clone().format(FORMAT)).isBetween(WEEK_END.clone().format(FORMAT), MONTH_END.clone().format(FORMAT))) {
        return 'This Month';
    } else if (momentDate.isAfter(MONTH_NEXT)) {
        return 'Upcoming';
    } else {
        return 'No Due Date';
    }
}
export const getSplitTime = (time) => {
    const converTime = convertTimeNumberToString(time)
    if (!converTime) return '00h 00m'
    const split = converTime.split(':')
    if (split.length === 2 && split[0] === "") return `00h ${split[1]}m`;
    else if (split.length === 2 && split[1] === "") return `${split[0]}h 00m`;
    else return `${split[0]}h ${split[1]}m`
}
export const updateUnReadCount = (message, messageList) => {
    return messageList.map((m, i) => {
        if (m?._id === message.referenceId) m.unreadCount = message.unreadCount || 0
        return m
    })
}
export const unreadCounter = (array, module, type) => {
    return array.filter(a => module.includes(a?.referenceType))?.find(e => type === 'my' ? e?.myUnRead?.isUnRead : type === 'employee' ? e?.employeeUnRead?.isUnRead : e?.isUnRead)
}
export const getCurrentFinancialYear = (date) => {
    let year = "";
    let today = date ? new Date(date) : new Date();
    if ((today.getMonth() + 1) <= 3) {
        year = (today.getFullYear() - 1) + "-" + today.getFullYear()
    } else {
        year = today.getFullYear() + "-" + (today.getFullYear() + 1)
    }
    return year
}
export const getStatusLabel = (obj) => {
    if (obj?.timeSheetType === HRMS_STATUS.TIME_SHEET_TYPE.WORK) {
        if (obj?.inTime && obj?.outTime) return 'Clock In/Out'
        else if (obj?.inTime) return 'Clock In';
        else if (obj?.outTime) return 'Clock Out';
    } else {
        if (obj?.inTime && obj?.outTime) return 'Break In/Out'
        else if (obj?.inTime) return 'Break In';
        else if (obj?.outTime) return 'Break Out';
    }
}
export const insertAtCaret = (areaId, text) => {
    let txtarea = document.getElementById(areaId);
    let scrollPos = txtarea.scrollTop;
    let strPos = 0;
    let br = ((txtarea.selectionStart || txtarea.selectionStart === '0') ?
        "ff" : (document.selection ? "ie" : false));
    if (br === "ie") {
        txtarea.focus();
        let range = document.selection.createRange();
        range.moveStart('character', -txtarea.value.length);
        strPos = range.text.length;
    } else if (br === "ff") strPos = txtarea.selectionStart;

    let front = (txtarea.value).substring(0, strPos);
    let back = (txtarea.value).substring(strPos, txtarea.value.length);
    txtarea.value = front + text + back;
    strPos = strPos + text.length;
    if (br === "ie") {
        txtarea.focus();
        let range = document.selection.createRange();
        range.moveStart('character', -txtarea.value.length);
        range.moveStart('character', strPos);
        range.moveEnd('character', 0);
        range.select();
    } else if (br === "ff") {
        txtarea.selectionStart = strPos;
        txtarea.selectionEnd = strPos;
        txtarea.focus();
    }
    txtarea.scrollTop = scrollPos;
}

/** get distance between lan & lng */
export const getDistance = (lat1, lat2, lon1, lon2) => {
    // The math module contains a function
    // named toRadians which converts from
    // degrees to radians.
    lon1 = lon1 * Math.PI / 180;
    lon2 = lon2 * Math.PI / 180;
    lat1 = lat1 * Math.PI / 180;
    lat2 = lat2 * Math.PI / 180;

    // Haversine formula
    let dlon = lon2 - lon1;
    let dlat = lat2 - lat1;
    let a = Math.pow(Math.sin(dlat / 2), 2)
        + Math.cos(lat1) * Math.cos(lat2)
        * Math.pow(Math.sin(dlon / 2), 2);

    let c = 2 * Math.asin(Math.sqrt(a));

    // Radius of earth in kilometers. Use 3956
    // for miles
    let r = 6371;

    // calculate the result
    return (c * r);
}

export const KMtoMeter = (km) => {
    return km * 1000;
}

export const getPayFrequency = (type) => {
    let frequency = "";
    switch (type) {
        case 1:
            frequency = 'Hourly'
            break;
        case 2:
            frequency = 'Monthly'
            break;
        case 3:
            frequency = 'Daily'
            break;
        case 5:
            frequency = 'Daily Pay Hourly'
            break;
        case 6:
            frequency = 'Monthly Pay Hourly'
            break;

        default:
            frequency = '-'
            break;
    }
    return frequency
}

export const getLeaveType = (item) => {
    if (item?.isNonWorkingDay && !item?.isLeave) {
        return 'Non Working Day'
    } else if (!item?.isLeave) {
        if (+item?.dayStatus === 2) {
            return 'Weekend'
        } else if (+item?.dayStatus === 1) {
            return 'Holiday'
        }
    } else if (item?.isLeave && item.type !== 4) {
        if (+item.type === 2) {
            return 'First Half'
        } else if (+item.type === 3) {
            return 'Second Half'
        } else if (+item.type === 5) {
            return 'Short Leave'
        } else {
            return 'Full Day'
        }
    } else if (item?.isLeave && item.type === 4) {
        if (+item?.dayStatus === 2) {
            return <td>Weekend</td>
        } else if (+item?.dayStatus === 1) {
            return <td>Holiday</td>
        } else {
            return <td> Total hours : {minutesToHm(item?.totalMin, true)} <br/> ({minutesTo12Hour(item?.startTime)} To {minutesTo12Hour(item?.endTime)}) </td>
        }
    }
}

export const getODType = (item) => {
    if (item?.isNonWorkingDay) {
        return 'Non Working Day'
    } else if (+item?.dayStatus === 2 && item?.type === 2) {
        return 'First Half(WK)'
    } else if (+item?.dayStatus === 2 && item?.type === 3) {
        return 'Second Half(WK)'
    } else if (+item?.dayStatus === 1) {
        return 'Holiday'
    } else if (+item?.dayStatus === 1 && item?.type === 2) {
        return 'First Half(HL)'
    } else if (+item?.dayStatus === 1 && item?.type === 3) {
        return 'Second Half(HL)'
    }else if(item.type === 4){
        return <td> Total hours : {minutesToHm(item?.totalMin, true)} <br/> ({minutesTo12Hour(item?.startTime)} To {minutesTo12Hour(item?.endTime)}) </td>
    }else if (item.type !== 4) {
        if (+item.type === 2) {
            return 'First Half'
        } else if (+item.type === 3) {
            return 'Second Half'
        } else if (+item.type === 5) {
            return 'Short Leave'
        } else {
            return 'Full Day'
        }
    } else if (item.type === 4) {
        if (+item?.dayStatus === 2) {
            return <td>Weekend</td>
        } else if (+item?.dayStatus === 1) {
            return <td>Holiday</td>
        }
    }
}

export const getUTC = (date = new Date(), flag) => {
    const convertedDate = moment.utc(date)
    if (flag === 'start') convertedDate.startOf('day')
    if (flag === 'end') convertedDate.endOf('day')
    return moment.utc(convertedDate).format()
}

export const getSandwichLeave = (policyList, data) => {
    data = policyList?.find(_ => (_?._id === data?.sLeavePolicy && data?.sLeave)); // overide value
    if (data?.name) {
        return `(Sandwich Leave :- ${data?.name})`;
    } else return ""
}

export const getFinancialYears = (dateYear, count = 0) => {
    const years = [];
    let startYear = new Date(dateYear).getMonth()+1 <= 3 ? new Date(dateYear).getFullYear() - 1 : new Date(dateYear).getFullYear();
    let currentYear = new Date().getMonth()+1 <= 3 ? new Date().getFullYear() - 1 : new Date().getFullYear();
    let endYear = currentYear + (count > 0 && startYear === currentYear ? count : 0);

    for (let year = count < 0 && startYear === currentYear ? startYear - 1 : startYear; year <= endYear; year++) {
        years.push({ label: `${year} - ${year + 1}`, value: `${year}-${year + 1}` });
    }

    return years.sort((a, b) => parseInt(b.value) - parseInt(a.value));
};

export const numFormatter = (num) => {
    return parseInt(num) > 99 ? '99' : num;
};

export const updateFaviconWithBadge = (notificationCount) => {
    const favicon = document.querySelector("link[rel~='icon']");
    if (!favicon) return;

    const originalFaviconUrl = favicon.getAttribute('data-original-href') || favicon.href;

    if (!favicon.getAttribute('data-original-href')) {
        favicon.setAttribute('data-original-href', originalFaviconUrl);
    }
    document.title = `${notificationCount ?  `(${ parseInt(notificationCount) > 99 ? '99+' : notificationCount }) | ` : ''}Superworks - HRMS`;
    if (notificationCount > 0) {
        const img = new Image();
        img.src = originalFaviconUrl;

        img.onload = () => {
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');

            canvas.width = img.width + 2;
            canvas.height = img.height + 2;

            context.drawImage(img, 0, 0, canvas.width, canvas.height);
            const radius = 6;
            const x = canvas.width - radius; // Adjusted x coordinate
            const y = canvas.height - 5; // Adjusted y coordinate

            context.beginPath();
            context.arc(x, y, radius, 0, 2 * Math.PI);
            context.fillStyle = 'red';
            context.fill();

            context.font = 'bold 10px Arial';
            context.fillStyle = 'white';
            context.textAlign = 'center';
            context.textBaseline = 'middle';
            context.fillText(numFormatter(notificationCount), x, y);

            favicon.href = canvas.toDataURL('image/png');
        };
    } else {
        favicon.href = originalFaviconUrl;
    }
}
export const getSeparateYears = (year, index, key) => {
    if (year) {
        if (year[key]) {
            const yearParts = year[key].split('-')[index];
            return yearParts;
        } else {
            const yearParts = year?.value?.split('-')[index] || year?.split('-')[index];
            return yearParts;
        }
    } else {
        return null;
    }
}


export const deepMerge = (target, source) => {
    // Ensure both target and source are objects
    if (!isObject(target) || !isObject(source)) {
        return target;
    }
    // Iterate over all keys in the source object
    for (const key of Object.keys(source)) {
        // If the value is an array, replace it entirely
        if (Array.isArray(source[key])) {
            target[key] = [...source[key]];
        }
        // If the value is an object, recursively merge
        else if (isObject(source[key])) {
            if (!target[key]) target[key] = {}; // Ensure the target key exists
            deepMerge(target[key], source[key]);
        }
        // Otherwise, directly assign the value
        else {
            target[key] = source[key];
        }
    }
    return target;
}

export const checkModule = (orgId, flag)=>{
    if(flag === 'profile-request') return window.location.origin?.includes("superworks.com") ? ALLOCATION.PROFILE_REQUEST.includes(orgId) : true
    if(flag === 'attendance-report') return (window.location.origin?.includes("superworks.com")) ? ALLOCATION.CUSTOM_SABBATICAL_LEAVE.includes(orgId) : true
}

export const handleGradeAndBandsLogic = (e, name, _GRADE) => {

    const payload = {
        [name]: e,
        currentPage: PAGINATION.CURRENT_PAGE
    };
    const selectedGradeId = e?.[0]?.grade;
    const matchedGrade = _GRADE.find(grade => grade._id === selectedGradeId);

    if (matchedGrade) {
        payload.grade = matchedGrade;
    }
    // Clear bands if grade is cleared
    if (name === 'grade' && !e) {
        payload.bands = null;
    }
    if (name === 'bands' && !e) {
        payload.bands = null;
    }
    if (name === 'grade' && e) {
        payload.bands = null;
    }
    // Clear grade if bands is cleared
    if (name === 'bands' && !e?.length) {
        payload.grade = null;
    }
    return payload;
};

export const ProgressPercentage = React.memo((props) => {
        return new Array(10).fill(1).map((_, i) => {
            return <span key={i}
                         className={`u_wd-activity ${props?.noActivity ? 'u_bg-pastelred' : props?.progressCount > i ? props?.progressCount <= 4 ? 'u_bg-green' : (props?.progressCount > 4 && props?.progressCount < 8) ? 'u_bg-green' : 'u_bg-green' : ''} `}/>
        })
    }
)

export const sendMessageRNW = (code, payload) => {
    /** code
     *
     * 0 : Logout event
     * 1 : After login give this object to the Native app {orgId: '', token: '', _id: ''}
     * 2 : For opening camera for capturing selfie for clock in/out with selfie clock in method : {}
     * 3 :
     * 4 :
     * 5 : This code will send current URL to HRMS application, when user on dashboard and press back button kill the app
     * 6 :
     * 7 : For background location tracking, this code will send the current location to HRMS application
     * 8 : For scanning face app open in HRMS application}
     * 9 :
     * 10 :
     * 11 :
     * 12 :
     * 13 : For QR scanner open in HRMS application {isQRScanner: true}
     * 14 :
     * 15 : For Quick links open in HRMS application {_id: "", link: "", isRead: "", name: ""}
     *
     * */
    window?.ReactNativeWebView?.postMessage(JSON.stringify({code, payload}));
    window?.webkit?.messageHandlers?.iosListener?.postMessage(JSON.stringify({code, payload}));
}

export const clearValidation = (validator = {}, keys = [], allClear = false) => {
    if (validator.current && validator.current.fields && keys?.length) {
        keys?.forEach(_ => {
            validator.current.hideMessageFor(_);
            delete validator.current.errorMessages[_];
            validator.current.fields[_] = true;
        });
        validator.current.hideMessages();
    }
    if (allClear) {
        // For clear All validation,  No need To pass keys one by one
        const keys = Object?.keys(validator.current.fields)
        if (keys?.length) {
            keys?.forEach(_ => {
                validator.current.hideMessageFor(_);
                delete validator.current.errorMessages[_];
                validator.current.fields[_] = true;
            });
            validator.current.hideMessages();
        }
    }
};

export const htmlToTag = (content, correctPlaceholders) => {
    const placeholderPattern = /{{.*?}}/g;
    return content?.replace(placeholderPattern, (placeholder) => {
        if (correctPlaceholders.includes(placeholder)) {
            placeholder = placeholder.replace(/^{{|}}$/g, "");
            return (`<span data-mce-mergetag-data="placeholder" class="mce-mergetag" contenteditable="true" data-mce-cef-wrappable="true" data-mce-mergetag="1">
                    <span class="mce-mergetag-affix" data-mce-mergetag-affix="">{{</span> <span class="mce-mergetag-placehoder" data-mce-mergetag-placehoder="{{${placeholder}}}">${placeholder}</span><span class="mce-mergetag-affix" data-mce-mergetag-affix="">}}</span>
                </span>`);
        }
        return placeholder;
    });
}

export const tagToHtml = (htmlString) => {
    // Create a DOM parser to parse the HTML string
    const parser = new DOMParser();
    const doc = parser?.parseFromString(htmlString, 'text/html');

    // Select all elements with the data-mce-mergetag-placehoder attribute
    const placeholders = doc?.querySelectorAll('[data-mce-mergetag-placehoder]');

    // Iterate over each placeholder and replace its content
    placeholders?.forEach((placeholderSpan) => {
        const placeholderValue = placeholderSpan?.getAttribute('data-mce-mergetag-placehoder');
        if (placeholderValue) {
            // Replace the entire outer span content with the placeholder value
            const outerSpan = placeholderSpan?.closest('.mce-mergetag');
            if (outerSpan) {
                outerSpan.outerHTML = placeholderValue;
            }
        }
    });

    // Serialize the modified DOM back into a string
    return doc.body.innerHTML;
}

export const toggleAttribute = (element, value = "", action) => {
    if(!element) return;

    const attrName = "data-ubs_custom-style";
    const currentValue = element.getAttribute(attrName) || "";
    let values = currentValue.split(" ").filter(v => v.trim());

    if (action === "add" && !values.includes(value)) {
        values.push(value);
    } else if (action === "remove") {
        values = values.filter(v => v !== value);
    }

    if (values.length) {
        element.setAttribute(attrName, values.join(" "));
    } else {
        element.removeAttribute(attrName);
    }
};

// ForMate keyName
export const  formatKeyName = (key) => {
    return key
        .replace(/([a-z])([A-Z])/g, "$1 $2") // camelCase to space
        .replace(/_/g, " ") // snake_case to space
        .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize words
}

export const getGradeOptions = (allValues, gradeList, jobTitleList) => {
    if (!Array.isArray(gradeList)) return [];

    if(!allValues?.jobTitle && !allValues?.bands) return gradeList
    if (allValues?.jobTitle) {
        const selectedJob = jobTitleList?.find(job => job?.value === allValues?.jobTitle);
        return gradeList.filter(e => selectedJob?.bands ? e.bands?.includes(selectedJob.bands) : !e?.bands?.length);
    } else if (allValues?.bands) {
        const filteredList = gradeList.filter(e => e.bands?.includes(allValues.bands));
        return filteredList.length ? filteredList : gradeList.filter(e => !e.bands?.length);
    }
};

export const getBandsOptions = (allValues, bandList, jobTitleList) => {
    if (!Array.isArray(bandList)) return [];

    const { grade, jobTitle } = allValues || {};

    if(!jobTitle && !grade) return bandList
    if (jobTitle) {
        const selectedJobBands = jobTitleList?.find(job => job.value === jobTitle)?.bands;
        return bandList.filter(e => selectedJobBands ? e.value === selectedJobBands : !e.jobTitle?.length);
    } else if (grade) {
        const filteredBands = bandList.filter(e => e.grade === grade);
        return filteredBands.length ? filteredBands : bandList.filter(e => !e.grade && !e?.jobTitle?.length);
    }

    return bandList;
};

export const getJobTitleOptions = (allValues, jobTitleList) => {
    if (!jobTitleList) return [];

    if (!allValues?.bands) return jobTitleList;

    const filtered = jobTitleList.filter(e => e.bands === allValues.bands);
    return filtered.length ? filtered : jobTitleList?.filter(e => !e?.bands);
};

/** Custom Fields : Utils START */

// For genration valid object id saved in Database

const logEnable = false;
export const generateObjectId = () => {
    return Math.floor(Date.now() / 1000)?.toString(16) + 'xxxxxxxxxxxxxxxx'?.replace(/[x]/g, () => (Math.random() * 16 | 0)?.toString(16));
};

export const isValueTruthy = (value) => {
    if (value === null || value === undefined) return false;
    if (isString(value)) return value.trim().length > 0;
    if (isArray(value)) return value.length > 0;
    if (value instanceof Date) return !isNaN(value.getTime()); // ✅ Check for valid Date
    if (isObject(value)) return Object.keys(value).length > 0;
    if (typeof value === 'boolean') return value === true;
    if (isNumber(value)) return value !== 0;

    return Boolean(value);
};


export const getActualField = (formValues, key) => {
    let result = "NOT_VALUE_MATCH";

    // Case 1: Array of objects
    if (Array.isArray(formValues) && formValues?.every(item => typeof item === "object" && !Array.isArray(item) && item !== null)) {
        result = formValues.find(item => item.key === key);
        return result || "NOT_VALUE_MATCH";
    }

    // Case 2: Array of arrays — search recursively inside each
    if (Array.isArray(formValues) && formValues?.every(item => Array.isArray(item))) {
        for (const innerArray of formValues) {
            result = getActualField(innerArray, key);
            if (result !== "NOT_VALUE_MATCH") return result;
        }
    }
    return result;
};

export const getFields = (keyList = [], allFields) => {
    const formValues = allFields ? cloneDeep(allFields) : null;
    if (logEnable) console.log(`===>>> getFields >> Params`, keyList, allFields)
    if (!formValues) {
        return [];
    }
    // Stores found objects for the requested keys.
    const results = [];
    // Keeps track of keys found to avoid duplicates.
    const visitedKeys = new Set();

    // Helper: Check if a value is a plain object.
    const isObject = (val) =>
        typeof val === "object" && val !== null && !Array.isArray(val);

    // Helper: Check if an array is entirely composed of objects.
    const isArrayOfObjects = (arr) =>
        Array.isArray(arr) && arr.every(item => isObject(item));

    // Recursive search function.
    const search = (input) => {
        // Ensure input is defined before proceeding.
        if (input == null) return;

        if (Array.isArray(input)) {
            // If it's an array of objects, try to find each requested key.
            if (isArrayOfObjects(input)) {
                keyList?.forEach(key => {
                    if (!visitedKeys.has(key)) {
                        // Use optional chaining to safely access properties.
                        const found = input?.find(item => item?.key === key);
                        if (found) {
                            results.push(found);
                            visitedKeys.add(key);
                        }
                    }
                });
            } else {
                // Otherwise, iterate through the array and search each element.
                for (const item of input) {
                    search(item);
                }
            }
        } else if (isObject(input)) {
            // If it's an object, search through its values.
            for (const val of Object.values(input || {})) {
                search(val);
            }
        }
    };

    // Kick off the recursive search.
    search(formValues);
    if (logEnable) console.log(`===>>> getFields >> results`, results)
    return results.length ? results : [];
};

export const conditionEvaluate = (condition, allFields) => {
    const {key, operator, value: expected, compareKey} = condition || {};
    if(logEnable) console.log("===>>> conditionEvaluate Params >> condition", condition, "\nallFields", allFields, "\nkey",key, "\noperator", operator)

    let actualField = getFields([key], allFields)
    if (actualField) actualField = actualField?.find(_ => _?.key === key);
    if(logEnable) console.log("===>>> conditionEvaluate >> actualField", actualField)
    let actual = actualField?.value;
    if(compareKey && actualField){
        actual = actualField[compareKey];
    }

    switch (operator) {
        case OPERATORS.EQUALS:
            return isEqual(actual, expected);

        case OPERATORS.NOT_EQUALS:
            return !isEqual(actual, expected);

        case OPERATORS.INCLUDES:
            return Array.isArray(actual) && actual.includes(expected);

        case OPERATORS.NOT_INCLUDES:
            return Array.isArray(actual) && !actual.includes(expected);

        case OPERATORS.GREATER_THAN:
            return actual > expected;

        case OPERATORS.LESS_THAN:
            return actual < expected;

        case OPERATORS.GREATER_EQUAL:
            return actual >= expected;

        case OPERATORS.LESS_EQUAL:
            return actual <= expected;

        case OPERATORS.CONTAINS:
            return actual?.includes?.(expected);

        case OPERATORS.EMPTY:
            return !isValueTruthy(actual);

        case OPERATORS.NOT_EMPTY:
            return isValueTruthy(actual);

        case OPERATORS.DATE_BEFORE:
            return isBefore(new Date(actual), new Date(expected));

        case OPERATORS.DATE_AFTER:
            return isAfter(new Date(actual), new Date(expected));

        case OPERATORS.IS_TRUTHY:
            return isValueTruthy(actual);
        case OPERATORS.IS_NOT_TRUTHY:
            return !isValueTruthy(actual);
        default:
            console.log("== OPERATOR IS NOT DEFINED ==")
            return null;
    }
};

export const checkCondition = ({logic = 'AND', conditions = [], allFields = []}) => {
    if(logEnable) console.log("===>>> checkCondition >> params", {logic, conditions, allFields})
    const results = conditions?.map(cond => conditionEvaluate(cond, allFields));
    if(logEnable) console.log("===>>> checkCondition >> results", results)
    return logic === 'OR' ? results?.some(Boolean) : results?.every(Boolean);
};

export const applyUpdates = (updatesList = [], data = [], dispatch = null) => {
    // Step 1: Build a map of updates for fast lookup
    const updatesMap = new Map();
    for (const item of updatesList) {
        if (item?.key && typeof item?.updateData === 'object') {
            updatesMap.set(item.key, item.updateData);
        }
    }

    // Helper: Check if value is a plain object
    const isObject = (val) =>
        typeof val === 'object' && val !== null && !Array.isArray(val);

    // Helper: Check if the object is a valid target for update
    const isUpdatableObject = (obj) =>
        isObject(obj) &&
        typeof obj.key === 'string' &&
        typeof obj._id === 'string';

    /**
     * Recursively update matching nested items
     * @param {any} input
     * @returns {any}
     */
    const recursiveUpdate = (input) => {
        if (Array.isArray(input)) {
            return input.map((item) => recursiveUpdate(item));
        } else if (isObject(input)) {
            // If this object matches update conditions, apply update
            if (isUpdatableObject(input) && updatesMap.has(input.key)) {
                const updates = updatesMap.get(input.key);
                const updated = {...input};

                // Merge each update property
                for (const [updateKey, updateValue] of Object.entries(updates)) {
                    updated[updateKey] = updateValue;
                    if(logEnable) console.log(`===>>> applyUpdates ========`, "\nupdateKey",updateKey, "\nupdateValue", updateValue, "\nfield",updated)
                }
                return updated;
            }

            // Otherwise, recursively update children
            const result = {};
            for (const [key, value] of Object.entries(input || {})) {
                result[key] = recursiveUpdate(value);
            }
            return result;
        }

        // Return primitives unchanged
        return input;
    };

    // Step 2: Deep clone the original data
    const cloned = cloneDeep(data);

    // Step 3: Apply updates recursively
    const updatedData = recursiveUpdate(cloned);

    if(typeof dispatch === 'function') {
        dispatch({type: "SET_ALL_FIELDS_CHANGE", payload: updatedData, isChange: true});
    }
    return updatedData;
}

// Helper function to set nested values
export const setNestedValue = (obj, path, key, value) => {
    const pathParts = path?.split(".")
    let current = obj
    // Navigate to the deepest level specified by path
    for (const part of pathParts) {
        if (!current[part]) {
            current[part] = {}
        }
        current = current[part]
    }
    // Set the value at the key
    current[key] = value || null;
}

export const prepareSaveData = (source = []) => {
    /**
     * This is Master Fn, You can modify it if you want to change data before sending it to the backend 
     * */ 
    let customFieldsData = {};
    let defaultFieldsData = {};

    if(Array?.isArray(source) && source?.length > 0){
        source?.forEach(field => {
            if (field?.type === CUSTOM_FIELD_TYPE.CONTACT) {
                if(field?.defaultKey){
                    defaultFieldsData[`${field?.defaultKey}CC`] = field?.[`${field?.defaultKey}CC`] || null;
                    defaultFieldsData[field?.defaultKey] = field?.value || null
                }else {
                    customFieldsData[`${field?.key}CC`] = field?.[`${field?.key}CC`] || null;
                    customFieldsData[field?.key] = field?.value || null 
                }
            }else if(field?.type === CUSTOM_FIELD_TYPE.DATE){
                if(field?.defaultKey){
                    defaultFieldsData[field?.defaultKey] = localToIST(field?.value) || null
                }else {
                    customFieldsData[field?.key] = localToIST(field?.value) || null
                }
            }else {
                if(field?.defaultKey){
                    defaultFieldsData[field?.defaultKey] = field?.value || null
                }else {
                    customFieldsData[field?.key] = field?.value || null
                }
            }
            
            if([D_FIELDS?.lastName_basic]?.includes(field?.key)){
                if(field?.defaultKey){
                    defaultFieldsData[field?.defaultKey] = field?.value || ""
                }
            }else if([D_FIELDS?.isPhysicalHandicap_basic]?.includes(field?.key)){
                if(field?.defaultKey){
                    defaultFieldsData[field?.defaultKey] = field?.value || false;
                }
            }
        })
    }

    return {customFieldsData, defaultFieldsData}
}

/** Custom Fields : Utils END */


export const parseIfJson = (data) => {
    try {
        // If it's already an object or array, return true
        if (typeof data === 'object' && data !== null) {
            return data;
        }

        // If it's a string, try parsing
        const parsed = JSON.parse(data);
        return (typeof parsed === 'object' && parsed !== null) ? parsed : null;
    } catch (error) {
        return null;
    }
};

// age calculate
export const calculateAge = (dobIso, untilIso = new Date()) => {
    const dob = new Date(dobIso);
    const until = new Date(untilIso);
  
    let age = until?.getFullYear() - dob?.getFullYear();
  
    const hasHadBirthday =
      until?.getMonth() > dob?.getMonth() ||
      (until?.getMonth() === dob?.getMonth() && until?.getDate() >= dob?.getDate());
  
    if (!hasHadBirthday) {
      age--;
    }
  
    return age || 0;
};

export const geocodeAddress = async (position) => {
    if (!window.google || !window.google.maps) {
        console.error('Google Maps JavaScript API is not loaded.');
        return '';
    }

    const geocoder = new window.google.maps.Geocoder();

    return new Promise((resolve) => {
        geocoder.geocode({ location: position }, (results, status) => {
            if (status === 'OK' && results?.length) {
                resolve(results[0].formatted_address);
            } else {
                console.error(`Geocoding failed: ${status}`);
                resolve('');
            }
        });
    });
};